import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SubscriptionCard } from '@shared/models/shared.models';
export interface HeaderTab {
  id: string,
  title: string,
  icon: string,
}

@Component({
    selector: 'app-multi-tab-header',
    templateUrl: './multi-tab-header.component.html',
    styleUrls: ['./multi-tab-header.component.scss'],
    standalone: false
})
export class MultiTabHeaderComponent {


  @Input() subscriptions: Array<SubscriptionCard>;
  @Input() set initialSubscription(value: SubscriptionCard) {
    this.selectedSub = value;
  }
  @Input() tabs: Array<HeaderTab>;
  @Input() set initialTab(value: string) {
    this.activeTab = value;
  }
  @Output() subscriptionChanged = new EventEmitter<string>();
  @Output() tabChanged = new EventEmitter<string>();

  dropdownToggle = false;
  activeTab: string;
  selectedSub: SubscriptionCard;

  /**
   * Toggles the subscription dropdown menu
   */
  toggleDropdown() {
    this.dropdownToggle = !this.dropdownToggle;
  }

  /**
   * Closes the subscription dropdown menu
   */
  closeDropdown() {
    this.dropdownToggle = false;
  }

  /**
   * Changes the currently selected subscription and emits an event to the parent component
   * @param subscription the newly selected subscription
   */
  subscriptionClicked(subscription: SubscriptionCard) {
    if (!subscription.entitled) {
      return;
    }
    this.selectedSub = subscription;
    this.subscriptionChanged.emit(subscription.id);
  }

  /**
   * Changes the currently selected tab
   * @param id the id of the new tab
   */
  tabClicked(id: string) {
    this.activeTab = id;
    this.tabChanged.emit(id);
  }

}
